import * as React from "react"
const SavedReports = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M5.833 14.166v-3.333M10 14.166V5.833M14.167 14.167v-5"
    />
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.083 10c0-3.732 0-5.598 1.16-6.758C4.403 2.083 6.268 2.083 10 2.083c3.732 0 5.598 0 6.757 1.16 1.16 1.159 1.16 3.025 1.16 6.757 0 3.732 0 5.598-1.16 6.757-1.16 1.16-3.025 1.16-6.757 1.16-3.732 0-5.598 0-6.757-1.16-1.16-1.16-1.16-3.025-1.16-6.757Z"
    />
  </svg>
)
export default SavedReports
